import { noop } from '@altirllc/shared/utils/functionalUtils';

import { PRODUCTION } from '@/constants';

import type { TTrack } from './types';
import { detailsToString } from './utils';

const track: TTrack = ({ level, ...details }) => {
  const formatted = detailsToString(details);

  console.info(`[HF | ${level}] ${formatted}`);
};

export const trackVerbose = PRODUCTION ? noop : track;
